import React from 'react'
import soiltestimg from '../images/our_services/soil_test_image.jpg';
import soiltestimg2x from '../images/our_services/soil_test_image@2x.jpg';
import bulleticon from '../images/soiltest/bullet_icon.svg';
import Image from 'next/image';

    const SoiltestContent = () => {
      return (
        <div className='w-full bg-white'>
            <div className='container max-w-screen-xl  flex flex-col mx-auto mb-3'>
                <p className=' text-ashred text-2xl my-3  flex'>
                Soil Resistivity Test
                </p>
                
                
                <p className='text-base text-justify '>
                The goal of soil resistivity testing is to obtain measurements that help model the electrical performance of the earth for a specific earthing system. Accurate results depend on proper investigation and correct test execution. Follow these guidelines:
                </p>
                <div>
                    <p className=' text-ashred text-3xl justify-center items-center font-semibold my-3'>
              
                    </p>
                    <ul className="list-none ml2 text-justify">
                        <li className="flex items-start"> <Image src={bulleticon} alt="Your Image" className="mr-2 pl-5 pt-2" /><p> <span style={{fontSize:'130%'}}>Initial Research:</span> Gather background data, including information on nearby metallic structures and the area&apos;s geological, geographical, and meteorological characteristics. This includes understanding soil strata, water retention properties, and recent rainfall data to assess if results are realistic</p></li>
                        <li className="flex items-start"> <Image src={bulleticon} alt="Your Image" className="mr-2 pl-5 pt-2" /><p><span style={{fontSize:'130%'}}>Factors Influencing Soil Resistivity:</span> Soil resistivity is affected by texture, mineral composition, grain size, compaction, temperature, and moisture content. It&apos;s crucial for designing effective earthing systems.
                        </p></li>
                        <li className="flex items-start"> <Image src={bulleticon} alt="Your Image" className="mr-2 pl-5 pt-2" /><p><span style={{fontSize:'130%'}}>Enhancing Earthing Resistance:</span> Use Backfill Compounds to improve earthing resistance in poor soil conditions. Place safe earth electrodes as deeply as possible, preferably in deeper strata.
                        </p></li>
                    </ul>
                </div>
               
                <div className='flex space-x-4'>
                    <div className="flex items-start w-1/2">
                        <div className='flex flex-col justify-start items-start text-justify'>
                                            
                            <div className='flex flex-col'> 
                                <p className=' text-base  '>
                                Calculating Soil Resistivity (Wenner Method): ρ = 2πAR

                                </p>
                                
                                <ul className="list-none ml2">
                                    <li className="flex items-center"> <Image src={bulleticon} alt="Your Image" className="mr-2 pl-5 pt-1" /> ρ= Average soil resistivity to depth A (ohm-cm) </li>
                                    <li className="flex items-center"> <Image src={bulleticon} alt="Your Image" className="mr-2 pl-5 pt-1" /> π = 3,1416</li>
                                    <li className="flex items-center"> <Image src={bulleticon} alt="Your Image" className="mr-2 pl-5" /> A = Distance between electrodes (cm)     </li>
                                    <li className="flex items-start"> <Image src={bulleticon} alt="Your Image" className="mr-2 pl-5 pt-1.5" /> R = Measured resistance value (ohm)
                                    </li>
                                </ul>
                                
                            </div>
                        </div>
                    </div>
                    <div className=" w-1/2 justify-start items-start">
                         <Image className=" pt-1.5" src={soiltestimg}  srcSet={`${soiltestimg} 1x, ${soiltestimg2x} 2x`}  alt="Soil Testing services provided byAshlok safe earthing"/>
                    </div>
                </div>
                <div className=' flex text-justify flex-col'>
                
                <p className=' text-ashred text-2xl lg:text-3xl justify-center items-center font-semibold my-3'>
                Four-Point Method:
                </p>
                <ul className="list-none ml2">
                    <li className="flex items-center"> <Image src={bulleticon} alt="Your Image" className="mr-2 pl-5" />Four electrodes spaced equidistantly and driven vertically into the ground
                    </li>
                    <li className="flex items-start"> <Image src={bulleticon} alt="Your Image" className="mr-2 pl-5 pt-1" />A test current I passes between the outer electrodes, measuring the potential V between the inner electrodes
                    </li>
                    <li className="flex items-center"> <Image src={bulleticon} alt="Your Image" className="mr-2 pl-5" />V/I provides resistance R
                    </li>
                    <li className="flex  items-start"> <Image  src={bulleticon} alt="Your Image" className="mr-2 pl-5 pt-1.5" />The tester uses Ohm’s Law (V = IR) to calculate soil resistance
                    </li>
                </ul>
                </div>
                <div>

                <p className=' text-ashred text-2xl lg:text-3xl justify-center items-center font-semibold my-3'>
                Benefits of Soil Resistivity Testing:
                </p>
                <ul className="list-none ml2">
                    <li className="flex items-center"> <Image src={bulleticon} alt="Your Image" className="mr-2 pl-5" />Ensures a well-protected and professional facility
                    </li>
                    <li className="flex items-center"> <Image src={bulleticon} alt="Your Image" className="mr-2 pl-5" />Helps select the type and material of earth electrode
                    </li>
                    <li className="flex items-center"> <Image src={bulleticon} alt="Your Image" className="mr-2 pl-5" />Demonstrates that many short rods are often more effective than a few long ones
                    </li>
                    <li className="flex  items-start"> <Image  src={bulleticon} alt="Your Image" className="mr-2 pl-5 pt-1.5" />Emphasizes the importance of the earthing system in site planning, which can be enhanced with conventional or advanced methods using electrodes with conductive backfill.
                    </li>
                </ul>

                </div>
                   
            </div>
            
          
        </div>
      )
    }
    
    export default SoiltestContent
    
